module.exports = __webpack_public_path__ + "images/content/create_todos_and_reminders.gif";